
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import SignUp from '~/components/UIComponents/SignUp.vue';

@Component({
  components: { FullScreenDialog, SignUp },
})
export default class SignUpModal extends Vue {
  @Prop({ type: String, default: '' })
  readonly header!: string;
  @Prop({ type: String, default: '' })
  readonly text!: string;
  @Prop({ default: '66' })
  readonly activeCampaignTag!: String;

  @State('showFilmEmailSignup') showFilmEmailSignupState!: boolean;

  @Mutation('toggleFilmEmailSignup')
  private toggleFilmEmailSignup!: (args: any) => void;

  sending = false;
  sent = false;
  sendError = '';

  get showFilmEmailSignup() {
    return this.showFilmEmailSignupState;
  }

  set showFilmEmailSignup(value) {
    this.toggleFilmEmailSignup(value);
  }

  beforeDestroy() {
    this.hideModal();
  }

  hideModal() {
    this.toggleFilmEmailSignup(false);
  }
}
